import FSectionSupportArticle from './model';
import SectionSupportArticle from './view';

export default {
  contentType: 'sectionSupportArticle',
  model: FSectionSupportArticle,
  view: SectionSupportArticle
};
